module.exports = __webpack_public_path__ + "static/img/13.dc49314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/13.jpg
// module id = Ob5k
// module chunks = 1